import React, { Fragment, useCallback, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Col, Row, Button, FormGroup, Form } from 'reactstrap';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { useAuth } from '../../Context/Auth/AuthContext';
import classnames from 'classnames';
import { toast } from 'react-toastify';
import WAM from '../../services/WAM';
import Strings from '../../translations/Translations';

const schema = Yup.object().shape({
  username: Yup.string().required(Strings('username_is_required')),
  email: Yup.string().email(Strings('email_invalid')).required(Strings('email_is_required')),
  password: Yup.string().required(Strings('password_is_required')).min(4, Strings('password_must_be_at_least_4_characters')),
  passwordrep: Yup.string().required(Strings('confirm_password_is_required')).oneOf([Yup.ref('password'), null], Strings('passwords_must_match'))
});

export default function SignUp(props) {
  const [width] = useState(window.innerWidth);
  const { toggleLoading } = useAuth();
  const history = useHistory();
  const { register, errors, handleSubmit, reset } = useForm({
    validationSchema: schema,
  });

  const onSubmit = useCallback(async (data) => {
    toggleLoading(true);

    try {
      const response = await WAM.signup(data.username, data.email, data.password);

      toggleLoading(false);

      if (response.result === 'success') {
        toast.success(Strings('user_successfully_created'));
        reset();
        history.replace('/');
      } else {
        const message = (response && response.error) ? response.error : Strings('error_on_create_user');
        toast.error(message);
      }
    } catch (err) {
      toggleLoading(false);
      toast.error(Strings('general_error'));
    }
  }, [toggleLoading, reset, history]);

  return (
    <Fragment>
      <div
        className={classnames('bg-animation', {
          'h-100': width > 1400,
        })}
      >
        <div
          className={classnames(
            'd-flex justify-content-center align-items-center',
            {
              'h-100': width > 1400,
            }
          )}
        >
          <Col md="8" className="mx-auto app-login-box">
            <div className="modal-dialog w-100">
              <div className="modal-content">
                <div className="modal-header">
                  <div className="h5 modal-title">
                    {Strings('application_title')}
                    <h6 className="mt-1 mb-0 opacity-8">
                      <span>
                        {Strings('create_an_account')}
                      </span>
                    </h6>
                  </div>
                </div>
                <div className="modal-body">
                  <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row form>
                      <Col md={12}>
                        <FormGroup>
                          <input
                            type="text"
                            name="username"
                            id="username"
                            placeholder={Strings('username')}
                            ref={register}
                            className="form-control"
                          />
                          {errors.username && (
                            <p className="error-validation text-left">
                              {errors.username.message}
                            </p>
                          )}
                        </FormGroup>
                      </Col>
                      <Col md={12}>
                        <FormGroup>
                          <input
                            type="email"
                            name="email"
                            id="email"
                            placeholder={Strings('email')}
                            ref={register}
                            className="form-control"
                          />
                          {errors.email && (
                            <p className="error-validation text-left">
                              {errors.email.message}
                            </p>
                          )}
                        </FormGroup>
                      </Col>
                      <Col md={12}>
                        <FormGroup>
                          <input
                            type="password"
                            name="password"
                            id="password"
                            placeholder={Strings('password')}
                            ref={register}
                            className="form-control"
                          />
                          {errors.password && (
                            <p className="error-validation text-left">
                              {errors.password.message}
                            </p>
                          )}
                        </FormGroup>
                      </Col>
                      <Col md={12}>
                        <FormGroup>
                          <input
                            type="password"
                            name="passwordrep"
                            id="passwordrep"
                            placeholder={Strings('confirm_password')}
                            ref={register}
                            className="form-control"
                          />
                          {errors.passwordrep && (
                            <p className="error-validation text-left">
                              {errors.passwordrep.message}
                            </p>
                          )}
                        </FormGroup>
                      </Col>
                      <Col md={12}>
                        <div className="text-center">
                          <small>
                            By signing up you agree with our <a href="https://www.photozig.com/policies/terms.htm" target="_blank" rel="noreferrer noopener">terms and conditions</a> and <a href="https://www.photozig.com/policies/privacy.html" target="_blank" rel="noreferrer noopener">privacy policy</a>.
                          </small>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                  <Row className="divider" />
                  <h6 className="mb-0">
                    <Link className="text-primary" to="/">
                      {Strings('return_to_login')}
                    </Link>
                  </h6>
                </div>
                <div className="modal-footer d-block text-center">
                  <Button
                    color="primary"
                    className="btn-wide btn-pill btn-shadow btn-hover-shine"
                    size="lg"
                    onClick={handleSubmit(onSubmit)}
                  >
                    {Strings('create_account')}
                  </Button>
                </div>
              </div>
            </div>
            <div className="text-center opacity-8 mt-3">
              Copyright &copy; Photozig Inc.
            </div>
          </Col>
        </div>
      </div>
    </Fragment>
  );
}
